import Reveal from "@/components/Reveal";

const points = [
  {
    num: "01",
    title: "STRATEGIC LOCATION",
    desc: "Probolinggo, East Java with convenient road access to Tanjung Tembaga Port.",
    testId: "why-location",
  },
  {
    num: "02",
    title: "±50,000 KL INSTALLED CAPACITY",
    desc: "Substantial installed storage capacity for bulk liquid requirements.",
    testId: "why-capacity",
  },
  {
    num: "03",
    title: "MULTIPLE TANK SIZES",
    desc: "3 × 15,000 KL · 2 × 2,000 KL · 1 × 1,000 KL",
    testId: "why-tanks",
  },
  {
    num: "04",
    title: "INTEGRATED HANDLING",
    desc: "Storage tank and pumping system with tanker truck access.",
    testId: "why-handling",
  },
  {
    num: "05",
    title: "FLEXIBLE STORAGE POSITIONING",
    desc: "External, overflow, buffer and temporary storage solutions.",
    testId: "why-flexibility",
  },
];

const WhyUjn = () => (
  <section id="why-ujn" data-testid="why-ujn-section" className="scroll-mt-20 bg-ujn-offwhite text-ujn-charcoal">
    <div className="mx-auto max-w-7xl px-5 py-20 sm:py-28 lg:px-8">
      <Reveal className="max-w-2xl">
        <p className="font-mono text-[11px] tracking-[0.28em] text-ujn-medium">WHY UJN</p>
        <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight text-ujn-deep sm:text-3xl lg:text-4xl">
          WHY PT UTAMA JAYA NITYA?
        </h2>
      </Reveal>

      <Reveal delay={0.1} className="mt-14 grid gap-px border border-ujn-medium/15 bg-ujn-medium/15 md:grid-cols-2 lg:grid-cols-3">
        {points.map((p) => (
          <div
            key={p.testId}
            data-testid={p.testId}
            className="group bg-ujn-offwhite p-8 transition-colors duration-300 hover:bg-ujn-sand sm:p-10"
          >
            <p className="font-mono text-sm tracking-[0.2em] text-ujn-medium">{p.num}</p>
            <h3 className="mt-6 font-heading text-lg font-semibold tracking-tight text-ujn-deep sm:text-xl">
              {p.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-ujn-charcoal/75 sm:text-base">{p.desc}</p>
          </div>
        ))}
        <div className="hidden bg-ujn-deep p-8 sm:p-10 md:col-span-2 lg:col-span-1 lg:block">
          <p className="font-mono text-sm tracking-[0.2em] text-ujn-subtle">UJN</p>
          <p className="mt-6 font-heading text-lg font-semibold leading-snug tracking-tight text-ujn-offwhite sm:text-xl">
            A practical platform for bulk-liquid requirements.
          </p>
          <p className="mt-3 font-mono text-[10px] tracking-[0.2em] text-ujn-offwhite/50">
            PROBOLINGGO — EAST JAVA — INDONESIA
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default WhyUjn;
